<aside class="count-action big-input-grid">
  <h4 class="to">
    <span>to</span>
  </h4>
  <div>
    <app-paired-autocomplete
      #actionDestinationCount [selectedFieldControl]="destinationControl"
      [secondaryEntityControl]="destinationDescriptorControl"
      [primaryEntity]="primaryEntity"
      [componentId]="'action-fieldValue-destination'"
      [entitiesOptions]="entitiesOptions"
      [inputRequired]="true"
      [dataSourceType]="dataSourceType"
      [placeholder]='countPlaceholder'
      [overlayPositioningConfig]="overlayPositioningConfig"
    >
    </app-paired-autocomplete>
  </div>
</aside>
